class CountdownShortcodeManager {
  constructor() {
    this.regex = /\[countdown[\s:]+([^\]]+)\]/gi;
    this.timers = [];
    this.intervalId = null;
    this.init();
  }

  init() {
    // Initial parse of the DOM
    this.parseDOM(document.body);
    
    // Start central timer loop (only ONE loop for all countdowns)
    this.startInterval();

    // Watch for dynamic DOM changes (e.g., Ajax Cart, infinite scroll)
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            this.parseDOM(node);
            shouldUpdate = true;
          }
        });
      });
      if (shouldUpdate) this.updateTimers();
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }

  parseDOM(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
    const nodesToReplace = [];

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.toLowerCase().includes('[countdown')) {
        nodesToReplace.push(node);
      }
    }

    nodesToReplace.forEach(node => {
      const parent = node.parentNode;
      // Skip script/style tags
      if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parent.tagName)) return;

      const text = node.nodeValue;
      if (!this.regex.test(text)) return;

      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      this.regex.lastIndex = 0; // reset regex state
      let match;

      while ((match = this.regex.exec(text)) !== null) {
        // Text before match
        if (match.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
        }

        // Create countdown span
        const span = document.createElement('span');
        span.className = 'js-countdown-timer tw:inline-block tw:font-bold tw:text-red-500 tw:ml-2 tw:tabular-nums tw:min-w-[135px]';
        span.textContent = '00d:00h:00m:00s';
        
        // Parse date (Fix Safari issue by converting YYYY-MM-DD to YYYY/MM/DD)
        const dateStr = match[1].replace(/-/g, '/');
        const endDate = new Date(dateStr).getTime();
        
        if (!isNaN(endDate)) {
            this.timers.push({ element: span, endDate: endDate });
        } else {
            span.textContent = '[Invalid Date]';
        }

        fragment.appendChild(span);
        lastIndex = this.regex.lastIndex;
      }

      // Text after last match
      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
      }

      parent.replaceChild(fragment, node);
    });
  }

  startInterval() {
    this.updateTimers(); // Run immediately
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(() => this.updateTimers(), 1000);
  }

  updateTimers() {
    if (this.timers.length === 0) return;
    const now = new Date().getTime();

    // Clean up memory: remove timers whose elements were deleted from DOM
    this.timers = this.timers.filter(timer => document.body.contains(timer.element));

    this.timers.forEach(timer => {
      const distance = timer.endDate - now;

      if (distance < 0) {
        timer.element.textContent = "00D:00H:00M:00S";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
      const seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');

      timer.element.textContent = `${days}D:${hours}H:${minutes}M:${seconds}S`;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Singleton pattern to ensure it only initializes once per page load
  if (!window.CountdownShortcodeManagerInstance) {
    window.CountdownShortcodeManagerInstance = new CountdownShortcodeManager();
  }
});
